<template>
  <section class="homeProduct">
    <div class="productBox">
      <div class="item" v-for="item in products" :key="item.id">
        <router-link :to="{name: 'mobileproduct', params: { id: item.id }}">
          <span class="tip">
            <span>¥</span>
            {{item.bonus_price}}
          </span>
          <div
            class="image"
            :style="'background:url('+item.img+') no-repeat;background-size:100%; '"
          ></div>
          <div class="title">{{item.title}}</div>
          <div class="price">
            新机价格
            <span><span>¥</span>{{item.price}}</span>
          </div>
          <p class="bonusprice">享环保补助金</p>
          <p class="btn">去换新</p>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props:["products"],
  data() {
    return {
    };
  }
};
</script>

<style scoped>
.homeProduct {
  width: 3.48rem;
  margin: 0rem auto 0.1rem;
}
.homeProduct h2 {
  font-size: 0.16rem;
  margin: 0.1rem 0;
  position: relative;
  padding-left: 0.1rem;
}
.homeProduct .more{
  font-weight: normal;
  float: right;
  font-size: 0.14rem;
}
.homeProduct h2:before {
  display: inline-block;
  content: "";
  width: 0.05rem;
  height: 0.15rem;
  background: #ffc95c;
  position: absolute;
  left: 0;
  top: 0.02rem;
  border-radius: 50px;
  font-weight: normal;
}

.productBox {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.21rem;
}
.productBox .item {
  width: 1.67rem;
  height: 2.3rem;
  text-align: center;
  position: relative;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.04rem 0px rgba(134, 130, 130, 0.3);
  border-radius: 0.05rem;
  margin-bottom: 0.12rem;
  font-size: 0.16rem;
}
.productBox .item:nth-child(2n) {
  margin-left: 0.12rem;
}
.productBox .item .tip {
  background: linear-gradient(
    93deg,
    rgba(249, 65, 93, 1) 0%,
    rgba(255, 183, 194, 1) 100%
  );
  width: 0.425rem;
  height: 0.205rem;
  color: #fff;
  border-bottom-left-radius: 50px;
  line-height: 0.205rem;
  text-align: right;
  padding-right: 0.05rem;
  position: absolute;
  font-size: 0.12rem;
  right: 0px;
  top: 0px;
  overflow: hidden;
}
.productBox .item .tip span {
  font-size: 0.08rem;
  margin-right: 0.01rem;
}
.productBox .item:nth-child(3n) {
  margin-right: 0;
}
.productBox .item .image {
  width: 0.8rem;
  height: 0.8rem;
  background-size: 100%;
  margin: 0.18rem auto 0.085rem;
}
.productBox .item .title {
  font-size: 0.14rem;
  height: 0.2rem;
  line-height: 0.2rem;
  overflow: hidden;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  overflow: hidden;
}
.productBox .item .price {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin: 0.11rem 0 0.12rem;
}
.productBox .item .price span {
  color: #f9415d;
  font-weight: bold;
}
.productBox .item .price span span{font-size:0.05rem;margin-right:0.02rem;}
.productBox .item .bonusprice {
  font-weight: 500;
  color: rgba(249, 65, 93, 1);
  font-size: 0.12rem;
}
.productBox .item .btn {
  width: 0.825rem;
  line-height: 0.25rem;
  background: rgba(250, 71, 98, 1);
  border-radius: 0.125rem;
  font-size: 0.13rem;
  color:#fff;
  text-align: center;
  margin:0.12rem auto 0;
}
</style>
